import { Checkbox, Form, FormInstance, Input, Select } from "antd";
import React, { useMemo } from "react";
import StyledModal from "../../components/CustomModal";
import { FooterButtons, FormWrapper, StyledButton, StyledNumberInput } from "../../components/styles";
import { useAppSelector } from "../../utils/hooks/redux";
import { selectUsers } from "../../redux/features/user/userSlice";
import { StyledPhoneInput } from "../ReportDetails/Modal/styles";
type ModalProps = {
  isEdit?: boolean;
  isModalOpen: boolean;
  handleSave: () => void;
  onCancel: () => void;
  form: FormInstance<any>;
  isEditMode?: boolean;
  loading?: boolean;
  hasAddPermission?: boolean;
  hasEditPermission?: boolean;
  hasViewPermission?: boolean;
};

const UserModal: React.FC<ModalProps> = ({ isModalOpen, handleSave, onCancel, form, loading, isEditMode, hasAddPermission, hasEditPermission, hasViewPermission }) => {

  const { roles } = useAppSelector(selectUsers);

  const rolesOptions = useMemo(() => roles.map((c) => ({ label: c.name, value: c.id })), [roles]);
  const canSaveChanges = useMemo(() => hasAddPermission || hasEditPermission, [hasAddPermission, hasEditPermission]);

  return (
    <StyledModal
      draggable={true}
      minHeight={"calc(100dvh - 550px)"}
      maxHeight={"calc(100dvh - 270px)"}
      title={!isEditMode ? `${canSaveChanges ? "Add" : "View"} New User` : `${canSaveChanges ? "Update" : "View"} User`}
      open={isModalOpen}
      closeIcon={null}
      footer={
        <FooterButtons>
          <StyledButton disabled={loading} onClick={onCancel}>Cancel</StyledButton>
          {canSaveChanges && <StyledButton loading={loading} onClick={handleSave} type="primary">
            {!isEditMode ? "Add" : "Update"}
          </StyledButton>}
        </FooterButtons>
      }
      centered
      onCancel={() => !loading && onCancel()}
    >
      <FormWrapper form={form} layout="vertical" disabled={loading || !canSaveChanges}>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter Email" },
            { type: "email", message: "Please enter valid Email" },
          ]}
          normalize={(value) => value?.trim().toLowerCase() || ""}
        >
          <Input size="large" />
        </Form.Item>
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "10px" }}>
          <Form.Item style={{ width: "100%" }} label="First Name" name="firstName" rules={[{ required: true, message: "Please enter first name" }]}>
            <Input size="large" />
          </Form.Item>
          <Form.Item style={{ width: "100%" }} label="Last Name" name="lastName" rules={[{ required: true, message: "Please enter last name" }]}>
            <Input size="large" />
          </Form.Item>
        </div>
        <Form.Item label="Phone Number (Optional)" name="phone" rules={[{ required: false, message: "Please enter phone number" }]}>
          <StyledPhoneInput
            country={"us"}
            inputProps={{
              placeholder: "Enter a Phone Number",
            }}
            inputStyle={{
              width: "100%",
              padding: "10px",
              borderRadius: "3px",
              fontSize: "15px",
              paddingLeft: "40px",
              background: "#fff",
              height: "40px",
              fontWeight: "400",
              color: "#333333"
            }}
            buttonStyle={{
              borderRight: "none",
            }}
          />
        </Form.Item>
        <Form.Item label="Role" name="role" rules={[{ required: true, message: "Select your role" }]}>
          <Select onChange={(value: string) => form.setFieldValue("role", value)} size="large" options={rolesOptions} placeholder="Select a role" />
        </Form.Item>

        <Form.Item name="isCaseManager" valuePropName="checked" initialValue={false}>
          <Checkbox>Case Manager</Checkbox>
        </Form.Item>

        <Form.Item name="isDeviceApprovalNotRequired" valuePropName="checked" initialValue={false}>
          <Checkbox>Skip Device Approval (User can login from any device without approval)</Checkbox>
        </Form.Item>
      </FormWrapper>
    </StyledModal>
  );
};

export default UserModal;
